import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';

import { Company } from '../../classess/company/company';
import { GlobalFormats } from '../../classess/main/globalFormats';

import {
    getProcessButtons, dataTableLanguaje, getDtRowIndex, isUndNull, isUndNullEmp, getLanguageObj, getResponse, setSeparatorsNumbers, settings, styles,
    handleResponseMessageAsync, LoadingSection
} from '../../helpers/main';
import useAuth from '../../auth/UseAuth';
import Menu from '../main/Menu';
import { StatementAccountByCustomer } from '../../classess/sales/statementAccountByCustomer';
import { SaleService } from '../../services/purchases/SaleService';
import TableIndex from '../main/TableIndex';
import AccessDenied from '../main/AccessDenied';

const $ = window.jqGlobal || window.jQuery;

const { app, backend, html, icons, images, labels, messages, } = settings;

const currentMethod = 'SaleUserCompanyCustomers';

export default function SaleUserCompanyCustomers({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
}) {
    //#region variables
    const { id, } = useParams();
    const auth = useAuth();
    const isMount = useRef(true);
    const dtSalesId = 'dtDevices';
    const [process, setProcess] = useState({
        showLoading: false,
    });
    const [showData, setShowData] = useState(true);
    const [company, setCompany] = useState(Company?.getClass({}, false));
    const [balanceTotals, setBalanceTotals] = useState({ documents: 0.00, others: 0.00, });
    const controls = {
        buttons: {
            back: {
                defaultClass: 'btn btn-outline-secondary shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnBack',
            },
        },
        icons: {
            back: {
                id: 'iconBack',
                defaultClass: icons?.fasFa?.arrowCircleLeft,
            },
        },
    };
    //#endregion variables

    //#region methods
    //#region statement account
    const getStatementAccountDetails = async ({
        e = {},
        customerId = '',
        description = '',
        rowId = '',
        subMethod = '',
    } = {}) => {
        const currentMethod = 'getStatementAccountDetails';
        let response = getResponse({ type: 0 });
        try {
            window.location.href = `${backend?.urls?.sales}${backend?.urls?.saleDetailStatementAccounts}/${id}/${customerId}`;
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    languageId: languageObj?.id,
                });
            }
        }
    }

    //#endregion statement account

    //#region others
    const getData = async ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'getData';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let companiesData = [];
            let customersData = [];
            let statementAccountTotalsByCustomer = [];
            let balanceTotalsData = { documents: 0.00, others: 0.00, };
            //#endregion variables

            if (auth?.isLoged({ subMethod: currentMethod })?.result) {
                setProcess(prev => ({ ...prev, showLoading: true }));
                setShowData(true);

                //#region datatable (set)
                response = setDataTables({ subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) return;
                //#endregion datatable (set)

                //#region set query code
                response = setQueryCode({ subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) return;
                //#endregion set query code

                //#region get data (statement account)
                response = await SaleService.getBillToPayCompanyCustomersAsync({
                    token: auth?.user?.token?.token,
                    companyId: parseInt(id),
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) return;

                companiesData = response?.result?.companies || [];
                setCompany(companiesData[0] || {});
                customersData = response?.result?.customers || [];
                statementAccountTotalsByCustomer = response?.result?.statementAccountTotalsByCustomer || [];
                balanceTotalsData = response?.result?.balanceTotals || balanceTotalsData;
                setBalanceTotals(balanceTotalsData);
                //#endregion get data (statement account)

                //#region set datatable
                if (!isUndNullEmp({ data: statementAccountTotalsByCustomer, subMethod: currentMethod, })?.result &&
                    statementAccountTotalsByCustomer.length > 0) {
                    response = setDataInDataTable({
                        statementAccountData: statementAccountTotalsByCustomer,
                        customersData: customersData,
                        subMethod: currentMethod,
                    });
                    if (!response?.isSuccess || response?.isWarning) return;
                }
                //#endregion set datatable
            } else {
                setShowData(false);
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false }));
            if (!response?.isSuccess) {
                setShowData(false);
            }
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    languageId: languageObj?.id,
                });
            }
        }
    }

    const setDataTables = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setDataTables';
        let response = getResponse({ type: 0 });
        try {
            //#region process
            $(`#${dtSalesId}`).DataTable({
                //buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: labels?.company?.[languageObj?.id], width: '55%', },
                    { title: labels?.balanceDocuments?.[languageObj?.id], className: 'text-right', width: '20%', },
                    { title: labels?.balanceOthers?.[languageObj?.id], className: 'text-right', width: '20%', },
                    { title: labels?.process[languageObj?.id], className: 'text-center', width: '5%', orderable: false, searchable: false, },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ code: languageObj?.id, }),
                order: [[0, 'asc']],
                responsive: true,
                lengthChange: true,
                autoWidth: false,
            });
            //.buttons().container().appendTo(`#${dtSalesId}_wrapper .col-md-6:eq(0)`);
            //#endregion process
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setQueryCode = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setQueryCode';
        let response = getResponse({ type: 0 });
        try {
            //#region process
            $(`#${dtSalesId} tbody`).on('click', 'tr', 'td', async function (e) {
                const rowId = getDtRowIndex({ dtId: dtSalesId, _this: this, subMethod: currentMethod })?.result;
                if (!isUndNull({ data: rowId, subMethod: currentMethod })?.result) {
                    const methodName = e?.target?.attributes?.method?.value || '';
                    const id_ = e?.target?.attributes?.id?.value || '';
                    const description = e?.target?.attributes?.description?.value || '';
                    switch (methodName) {
                        case 'details':
                            getStatementAccountDetails({ e: e, customerId: id_, description: description, rowId: rowId, subMethod: currentMethod, });
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion process
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setDataInDataTable = ({
        statementAccountData = [],
        customersData = [],
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setDataInDataTable';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            const statementAccountDt = [];
            //#endregion variables

            //#region process
            statementAccountData.forEach((value) => {
                const sabcModel = StatementAccountByCustomer?.class(value, false);
                const customerModel = Company?.getClass(
                    customersData.filter(({ secundaryId, }) => secundaryId === sabcModel.cCodEmpresa)[0] || {},
                    false
                );
                const processButtons = [];

                statementAccountDt.push([
                    customerModel.name,
                    setSeparatorsNumbers({ number: sabcModel.balanceDocument, withDecimals: true })?.result,
                    setSeparatorsNumbers({ number: sabcModel.balanceDeliveryNote, withDecimals: true })?.result,
                    getProcessButtons({
                        id: customerModel.id,
                        description: customerModel.name,
                        showDetails: true,
                        labelDetails: labels?.details[languageObj?.id],
                        enabledDetails: (sabcModel.balanceDocument !== 0.00 || sabcModel.balanceDeliveryNote !== 0.00),
                        showDelete: false,
                        labelDelete: labels?.delete[languageObj?.id],
                        enabledDelete: false,
                        showEdit: false,
                        labelEdit: labels?.edit?.[languageObj?.id],
                        enabledEdit: false,
                        processButtons: processButtons,
                    })?.result,
                ]);
            });

            $(`#${dtSalesId}`)?.DataTable()?.rows?.add(statementAccountDt)?.draw(true);
            //#endregion process
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    useEffect(() => {
        isMount.current = true;
        getData({ subMethod: 'form - onLoad' });
        return () => {
            isMount.current = false;
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion others
    //#endregion methods

    return (
        <div>
            <Menu viewName={app?.views?.purchases?.billToPay} process={app?.views?.purchases?.billToPay} />

            <div className='content-wrapper bg-transparent'>

                {/* Content Header (Page header) - Premium Bar v6.6 */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2 align-items-center bg-white p-3 rounded shadow-lg mx-0'>
                            <div className='col-sm-6'>
                                <h4 className='m-0 font-weight-bold text-dark'>{labels?.detailCompanyCustomers?.[languageObj?.id]}</h4>
                            </div>
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right bg-transparent mb-0 justify-content-center justify-content-sm-end'>
                                    <li className='breadcrumb-item'><a href='/' className='text-muted'>{labels?.home?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item'><a href={backend?.urls?.sales} className='text-muted'>{labels?.billToPay?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item active text-primary font-weight-bold'>{labels?.detailCompanyCustomers?.[languageObj?.id]}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>

                        {auth?.isLoged({ subMethod: currentMethod })?.result ? (
                            <div className='row'>
                                <div className='col-12'>
                                    {showData ? (

                                        <div className={html?.cards?.default} style={{ borderRadius: '10px' }}>
                                            <LoadingSection
                                                alt='loadingSection'
                                                className='overlay dark text-white'
                                                height={20}
                                                hidden={!process?.showLoading}
                                                languageId={languageObj?.id}
                                                showText={true}
                                                width={20}
                                                subMethod={currentMethod} />

                                            <div className='card-header bg-white border-bottom-0 pt-4 px-4'>
                                                <div className='d-flex align-items-center flex-wrap justify-content-between'>
                                                    <div className='d-flex align-items-center mb-2 mb-md-0'>
                                                        <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                                            style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                            <img alt={labels?.company?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={images?.icons?.company}></img>
                                                        </div>
                                                        <div className='d-flex flex-column'>
                                                            <h5 className='mb-0 font-weight-bold text-dark'>{company?.name || ''}</h5>
                                                            <div className='mt-1'>
                                                                <span className='badge badge-pill badge-info px-2 py-1 text-uppercase' style={{ fontSize: '0.65rem', fontWeight: '800', letterSpacing: '0.8px' }}>
                                                                    <i className='fas fa-building mr-1'></i> {labels?.company?.[languageObj?.id]}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='ml-auto'>
                                                        <a className={`${controls?.buttons?.back?.defaultClass}`}
                                                            href={backend?.urls?.sales}>
                                                            <i className={controls?.icons?.back?.defaultClass}> </i> {labels?.back?.[languageObj?.id]}
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='card-body px-4 pb-0 mt-2'>
                                                <TableIndex tableId={dtSalesId} languageObj={languageObj} />
                                            </div>

                                            <div className='card-footer bg-white border-top-0 pb-4 px-4 pt-0 mt-3'>
                                                <div className='row text-center align-items-center'>
                                                    <div className='col-md-6 d-none d-md-flex justify-content-start align-items-center'>
                                                        <div className='text-right mr-3'>
                                                            <small className='text-muted d-block'>{messages?.processCompletedSuccessfully?.[languageObj?.id]}</small>
                                                            <span className='badge badge-success px-3 shadow-sm'>{labels?.customerData?.[languageObj?.id]}</span>
                                                        </div>
                                                        <i className='fas fa-users text-muted fa-2x opacity-25'></i>
                                                    </div>
                                                    <div className='col-sm-6 col-md-3 mb-3 mb-md-0'>
                                                        <div className='p-3 rounded bg-light border-left border-info shadow-sm h-100' style={{ borderRadius: '10px', borderLeftWidth: '5px' }}>
                                                            <small className='text-muted text-uppercase mb-1' style={{ fontSize: '0.65rem', fontWeight: '800', letterSpacing: '0.8px' }}>{labels?.balanceDocuments?.[languageObj?.id]}</small>
                                                            <h5 className='mb-0 font-weight-bold text-dark'>
                                                                {setSeparatorsNumbers({ number: balanceTotals.documents, withDecimals: true, })?.result}
                                                            </h5>
                                                        </div>
                                                    </div>
                                                    <div className='col-sm-6 col-md-3 mb-3 mb-md-0'>
                                                        <div className='p-3 rounded bg-light border-left border-primary shadow-sm h-100' style={{ borderRadius: '10px', borderLeftWidth: '5px' }}>
                                                            <small className='text-muted text-uppercase mb-1' style={{ fontSize: '0.65rem', fontWeight: '800', letterSpacing: '0.8px' }}>{labels?.balanceOthers?.[languageObj?.id]}</small>
                                                            <h5 className='mb-0 font-weight-bold text-dark'>
                                                                {setSeparatorsNumbers({ number: balanceTotals.others, withDecimals: true, })?.result}
                                                            </h5>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    ) : (
                                        <div></div>
                                    )}
                                </div>
                            </div>
                        ) : (
                            <AccessDenied languageObj={languageObj} />
                        )}
                    </div>
                </section>

            </div>
        </div>
    )
}